import React, { useState, useEffect } from "react";
import axios from "axios";

const MacaronsRecipeComponent = ({
  addIngredientsToCart,
  nameOfIngredients,
}) => {
  const [message, setMessage] = useState("");
  const [allItems, setAllItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    // Fetch all items from your API
    axios
      .get(`${process.env.REACT_APP_BACKEND_API}/products`)
      .then((response) => {
        setAllItems(response.data);
      })
      .catch((error) => {
        console.error("Error fetching all items:", error);
      });
  }, []);

  useEffect(() => {
    if (nameOfIngredients && nameOfIngredients.length > 0) {
      const filtered = allItems.filter((item) =>
        nameOfIngredients.includes(item.product_name)
      );
      setFilteredItems(filtered);
    }
  }, [nameOfIngredients, allItems]);

  const handleAddToCartClick = () => {
    try {
      const newItemAddedToFood = [];
      if (addIngredientsToCart && filteredItems.length > 0) {
        filteredItems.forEach((product) => {
          const food = {
            name: product.product_name,
            image: product.product_image,
            id: product.product_id,
            length: 1,
          };
          newItemAddedToFood.push(food);
        });

        addIngredientsToCart(newItemAddedToFood);

        setMessage("Ingredients have been added to your cart.");
      } else {
        setMessage("No specific ingredients selected to add to the cart.");
      }
    } catch (error) {
      console.error("Error adding ingredients to cart:", error);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 dark:text-white p-4 shadow-md rounded-lg">
    <div className="grid grid-cols-2">
      <div>
        <h3 className="text-2xl font-extrabold mb-8 text-center">Macarons</h3>
      <img
        src="https://resize.img.allw.mn/thumbs/00/surd8r8ca2rka63zdt9in_1080_1225.jpg?width=1200&height=1200"
        alt="Macarons"
        className="w-full h-60 object-contain"
        />
      </div>
      <div>
        <h3 className="text-xl font-bold mb-8">Ingredients</h3>
        <ul className="list-disc pl-6 mb-4">
          <li className="mb-4">1 cup almond flour</li>
          <li className="mb-4">2 cups confectioners' sugar</li>
          <li className="mb-4">3 large egg whites, room temperature</li>
          <li className="mb-4">1/4 cup granulated sugar</li>
          <li className="mb-4">1/2 teaspoon vanilla extract</li>
          <li className="mb-4">Food coloring (optional)</li>
          </ul>
        </div>
      </div>

      <div>
        <h3 className="text-xl font-bold mb-8">Directions</h3>
        <ol className="pl-6 mb-4">
          <li className="mb-4">
            <strong className="text-xl">Step 1:</strong> In a food processor, pulse almond flour and
            confectioners' sugar until well combined. Sift the mixture through a
            fine-mesh sieve into a large bowl; discard any large pieces.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 2:</strong> In a separate bowl, beat egg whites with a
            hand mixer until foamy. Gradually add granulated sugar and continue
            to beat until stiff, glossy peaks form. Add vanilla extract and food
            coloring (if desired), and mix until combined.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 3:</strong> Gently fold the almond flour mixture into
            the egg white mixture until fully combined and smooth.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 4:</strong> Transfer the batter to a pastry bag fitted
            with a 1/2-inch round tip. Pipe small circles onto parchment-lined
            baking sheets, spacing them about 1 inch apart.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 5:</strong> Tap the baking sheets on the counter to
            remove any air bubbles. Let the macarons sit at room temperature for
            30 minutes to 1 hour, or until a skin forms and they are no longer
            sticky to the touch.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 6:</strong> Preheat your oven to 300°F (150°C). Bake
            the macarons for 15-18 minutes, or until they lift easily from the
            parchment paper. Let them cool completely on the baking sheets.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 7:</strong> Once cooled, carefully remove the macarons
            from the parchment paper and match them up by size.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 8:</strong> Fill the macarons with your favorite
            filling, such as ganache or buttercream. Sandwich them together and
            refrigerate for 24 hours to let the flavors meld.
          </li>
          <li className="mb-4">
            <strong className="text-xl">Step 9:</strong> Enjoy your homemade Macarons!
          </li>
        </ol>
      </div>

      <div className="flex justify-center">
        <button
          onClick={handleAddToCartClick}
          className="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900"
        >
          Add All Ingredients To Cart
        </button>
      </div>

      {message && <p className="mt-4">{message}</p>}
    </div>
  );
};

export default MacaronsRecipeComponent;
